<template>
  <div class="d-flex flex-wrap flex-md-nowrap mt-3 mb-3">
    <div class="me-0 me-md-3 mb-3 flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <button @click="navigatePrevious" v-show="!isFirst()" class="btn btn-red w-100">
        {{ previousButtonText() }}
      </button>
    </div>
    <div class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <button
        @click="navigateNext"
        class="btn btn-red w-100"
        :disabled="invalid || !$store.state.canProceedToNextPage || !this.insuranceYearlyPrice"
      >
        {{ nextButtonText() }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Swal from 'sweetalert2';

export default {
  props: ['invalid', 'validate'],
  methods: {
    ...mapActions(['verifyPage']),
    nextButtonText() {
      if (this.$store.state.page === 1) return 'Tovább a szerződés adatokra';
      else if (this.$store.state.page === 2) return 'Tovább az összesítésre';
      else return 'Megkötöm a biztosítást';
    },

    previousButtonText() {
      if (this.$store.state.page === 2) return 'Vissza az alap adatokra';
      else return 'Vissza a szerződés adatokra';
    },

    isFirst() {
      return this.$store.state.page === 1;
    },

    confirmNormalOffer() {
      Swal.fire({
        icon: 'warning',
        html:
          '<b>Figyelem!</b><br><div>A gomb megnyomásával Ön leadja igényét a biztosítási szerződés megkötésére!<div>',
        showCloseButton: true,
        showConfirmButton: true,
        showDenyButton: true,
        denyButtonText: 'Mégsem',
        confirmButtonText: 'Megkötöm',
        customClass: {
          content: 'text-align-center',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.normalOffer();
        }
      });
    },

    async normalOffer() {
      await this.verifyPage(3);
      // await this.verifyPage(4);

      this.$store.commit('setFormSubmitLoading', true);
    },
    async navigateNext() {
      await this.validate();

      if (this.invalid) return;

      if (this.$store.state.page === 3) {
        if (!this.$store.state.canProceedToNextPage || this.invalid) return;

        this.confirmNormalOffer();

        // await this.verifyPage(3);

        // await this.verifyPage(4);

        // this.$store.commit('setFormSubmitLoading', true);
      } else {
        try {
          const {data: result} = await this.verifyPage(this.$store.state.page);

          if (
            result?.fieldErrors?.length <= 0 &&
            result?.generalErrors?.length <= 0 &&
            !this.invalid
          ) {
            this.$store.commit('incrementPage');
          }
        } catch (e) {
          console.error(e);
        }
      }
    },

    navigatePrevious() {
      this.$store.commit('decrementPage');
    },
  },
  computed: {
    ...mapFields(['currency', 'insuranceYearlyPrice']),
  },
};
</script>

<style lang="scss">
@media only screen and (min-width: 768px) {
  .w-md-auto {
    max-width: fit-content !important;
    width: auto !important;
  }
}
</style>
